export default "__VITE_ASSET__fec2a341__"